
import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
//import { ProductService } from './service/ProductService';

import { ApiCallGet } from '../../../../ApiCall/ApiCall';
import { getUrl } from '../../../../ApiCall/GetUrl';

// { state : { id : response.id , name : response.name , logg_express : response.logg_express }} ) 



export default function CitasLawyer( { state , change }) {
    const [products, setProducts] = useState([]);
    const columns = [
        {field: 'datetime', header: 'Fecha Cita'},
        {field: 'name', header: 'Cliente'},
        {field: 'phone', header: 'Telefono'},
        {field: 'comment', header: 'Comentario'},
        {field: 'estatus', header: 'Estatus'},
        //{field: 'quantity', header: 'Quantity'}
    ];

    

    useEffect(() => {
        ApiCallGet(  "/citaslawyer?id=" + state.id )
        .then(( response) =>{

            console.log( "citasLawyer = " , response )

            var arr = []

            for( var i = 0 ; i < response.length ; i++ )
            {
                var obj = {}

                // localDate.setHours(localDate.getHours() + 2);

                var localDate = new Date( response[i].datetime )

                console.log( "localDate = " , localDate )

                localDate.setHours(localDate.getHours() + 2);


                obj.datetime = getFormatDate( localDate )
                obj.estatus = "Espera"
                obj.name = response[i].name 
                obj.phone = response[i].phone 
                obj.comment = response[i].comment 

                arr.push( obj )
            }

            setProducts( arr )

            

        })
        .catch((err) => {
            console.log( err )
        })
        
    }, [change]);


    function getFormatDate(d) {
        var date = new Date(d);
        var dateStr =
            date.getFullYear() + "-" +
            ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("00" + date.getDate()).slice(-2) + " " +
          ("00" + date.getHours()).slice(-2) + ":" +
          ("00" + date.getMinutes()).slice(-2) + ":" +
          ("00" + date.getSeconds()).slice(-2);
        //console.log(dateStr);
      
        return dateStr;
      }

    return (
        <div className="card">
            <h3>Citas abogado {state.name}</h3>
            <DataTable value={products} tableStyle={{ minWidth: '50rem' }}>
                {columns.map((col, i) => (
                    <Column key={col.field} field={col.field} header={col.header} />
                ))}
            </DataTable>
        </div>
    );
}
        